document.addEventListener('DOMContentLoaded', () => {
  function updateTooltipPosition(tooltip, event) {
    // Get cursor position
    const x = event.clientX;
    const y = event.clientY;
    
    // Apply the cursor position to the tooltip
    tooltip.style.setProperty('--tooltip-left', `${x}px`);
    tooltip.style.setProperty('--tooltip-top', `${y}px`);
  }

  // Handle hover events for variant tooltips
  document.querySelectorAll('.swatch-container').forEach(container => {
    const tooltip = container.querySelector('.variant-swatch-tooltip');
    if (tooltip) {
      container.addEventListener('mousemove', (event) => {
        updateTooltipPosition(tooltip, event);
      });
    }
  });

  // Handle hover events for sibling tooltips
  document.querySelectorAll('.color-watches[aria-label]').forEach(swatch => {
    swatch.addEventListener('mousemove', (event) => {
      // Create a temporary element to measure the tooltip
      const tempTooltip = document.createElement('div');
      tempTooltip.className = 'tooltip-base';
      tempTooltip.textContent = swatch.getAttribute('aria-label');
      document.body.appendChild(tempTooltip);
      
      // Update position based on cursor
      updateTooltipPosition(tempTooltip, event);
      
      // Apply the calculated position to the pseudo-element
      swatch.style.setProperty('--tooltip-left', tempTooltip.style.getPropertyValue('--tooltip-left'));
      swatch.style.setProperty('--tooltip-top', tempTooltip.style.getPropertyValue('--tooltip-top'));
      
      // Clean up
      document.body.removeChild(tempTooltip);
    });
  });
}); 